/** @format */
import { pickBy } from 'lodash';
import qs from 'qs';

/**
 * Prepares a canonical reference to the current page being viewed
 * ensuring that only certain URL parameters are present

 * @param {string[]} allowedUrlParams An array of permitted URL params
 * @return {string} The canonical reference
 */
export function getCanonicalHref(
    allowedUrlParams: string[] = []
): string | undefined {
    if (typeof window === 'undefined') {
        return undefined;
    }

    const params = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
    });

    const preparedParams = qs.stringify(
        pickBy(params, (value: any, key: string) =>
            allowedUrlParams.includes(key)
        ),
        { addQueryPrefix: true }
    );

    return `${window.location.protocol}//${window.location.host}${window.location.pathname}${preparedParams}`;
}
